<template>
    <!-- エラー時にアイコンを付けるラベル -->
    <div style="margin-top: 26px; margin-bottom: 2px">
        <div style="font-weight: bold; color: #9c7aaa;">
            {{text}} <span v-if="sub" style="color: tomato; font-size: 0.85rem; display: inline-block;">{{sub}}</span>
        </div>

        <div v-if="error && error!=''" style="display: flex; align-items: center; gap: 3px; margin-top: -3px;">
            <div v-if="error" style="background: red; border-radius: 3px; width: 12px; height: 13px;">
                <div style="width: 2px; height: 5px; background: white; margin: 2px 5px 0 5px;"></div>
                <div style="width: 2px; height: 2px; background: white; margin: 2px 5px 0 5px;"></div>
            </div>
            <div v-if="error" attention-label-error style="color: red; font-size: 0.95rem;">{{error}}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        text:{
            type: String,
            default: "",
        },
        sub:{
            type: String,
            default: "",
        },
        error:{
            default: "",
        }
    },
}
</script>

<style scoped>
#xxx{
    color:#9c7aaa;
}
</style>